export const DEVICE_REQUEST_STATUS_CONSTANT = {
  ACCEPTED: 1,
  REJECTED: 2,
  PENDING: 0,
}

export const TELEMETRY_DATA_TYPE_NAME = {
  SYSTOLIC_PRESSURE: 'systolic_pressure',
  DIASTOLIC_PRESSURE: 'diastolic_pressure',
  PULSE: 'pulse',
}

export const TELEMETRY_DATA_TYPE_UNIT = {
  MMHG: 'mmHg',
  BPM: 'bpm',
}

export const SEVERITY_LEVELS = {
  LOW: {
    value: '1',
    label: 'Low',
  },
  NORMAL: {
    value: '2',
    label: 'Normal',
  },
  ELEVATED: {
    value: '3',
    label: 'Elevated',
  },
  HYPER_TENSION_STAGE_01: {
    value: '4',
    label: 'Hypertension Stage 1',
  },
  HYPER_TENSION_STAGE_02: {
    value: '5',
    label: 'Hypertension Stage 2',
  },
  HYPERTENSIVE_CRISIS: {
    value: '6',
    label: 'Hypertensive Crisis',
  },
  // CRITICAL: {
  //   value: '1',
  //   label: 'Critical',
  // },
  // WARNING: {
  //   value: '2',
  //   label: 'Warning',
  // },
  // MODERATE: {
  //   value: '3',
  //   label: 'Moderate',
  // },
}

export const USER_ROLES = {
  ADMIN: 1,
  DOCTOR: 2,
  NURSE: 3, // TODO::Rename to ??
  SUB_ADMIN: 4,
  BILLING_PERSONNEL: 5,
  MEDICAL_ASSISTANT: 6,
}

export type BPSeverity = 'Crisis' | 'Stage 2' | 'Stage 1' | 'Elevated' | 'Low'

export interface CategoryConfig {
  key: string // your API field name (e.g. 'hypertensionCrisis')
  label: BPSeverity // the human-readable status
  class: string // the utility class for bg-/text- (e.g. 'bg-crisis')
}

export const categoryConfigs: CategoryConfig[] = [
  {key: 'hypertensionCrisis', label: 'Crisis', class: 'bg-crisis'},
  {key: 'hypertensionStage2', label: 'Stage 2', class: 'bg-stage2'},
  {key: 'hypertensionStage1', label: 'Stage 1', class: 'bg-stage1'},
  {key: 'elevated', label: 'Elevated', class: 'bg-elevated'},
  // { key: 'low',               label: 'Low',      class: 'bg-low'      },
]
